import React from 'react';
import PropTypes from 'prop-types';

import { ListItem } from 'material-ui';

import { reverseListItemLabels } from 'config';

const styles = {
  defaultInnerDivStyle: {
    display: 'flex',
    flexDirection: reverseListItemLabels ? 'column-reverse' : 'column',
  },
  primaryTextStyle: {
    marginTop: reverseListItemLabels ? 6 : 0,
  },
};

const KListItem = ({
  innerDivStyle,
  primaryText,
  ...props
}) => (
  <ListItem
    innerDivStyle={{
      ...innerDivStyle,
      ...styles.defaultInnerDivStyle,
    }}
    primaryText={
      <div style={styles.primaryTextStyle}>
        {primaryText}
      </div>
    }
    {...props}
  />
);

KListItem.propTypes = {
  innerDivStyle: PropTypes.object,
  primaryText: PropTypes.node,
};

export default KListItem;



// WEBPACK FOOTER //
// ./src/components/KJRN/KListItem.js